import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./HeadlineBlock').then(m => ({default: m.HeadlineBlock})),
)

export const headlineBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
  ssrEnabled: false,
})
